import DataPageView from './dataPage';

export * from './dataPage';

export default DataPageView;
